import {
  getReduxSelector,
  getTypeInstanceUtil,
  MEDIA_MODEL_TYPE,
  MEDIA_PATH
} from '@gymaholic/packages'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getInstancesFromMapReduxUtil from '@gymaholic/packages/src/modules/redux/utils/get-instances-from-map/index.js'
import getMediaByIdProfileSelector from 'modules/profile/redux/selectors/get-media-by-id/index.js'

export default function getMediaImageProfileByIdSelector (id) {
  return state => {
    const mediaPointers = getMediaByIdProfileSelector(id)(state)
    const media = getInstancesFromMapReduxUtil(
      getReduxSelector(MEDIA_PATH.DATA)(state),
      mediaPointers.map(getIdReduxUtil)
    )
    return media.find(item => getTypeInstanceUtil(item) === MEDIA_MODEL_TYPE.IMAGE)
  }
}
